import { GenericWrapperContext, SideMenuItem } from "cakemail-ui-components-v2"
import { useContext, useEffect } from "react"
import { Stack } from "@mui/material"
import { useTranslation } from "react-i18next"
import "./styles.scss"
import { TManageAccountsConfirmationSetup } from "./types"
import { OnboardingContext } from "../../context"
import { EOnboardingStep } from "../../types"

export function ManageAccountsConfirmationSetup({ }: TManageAccountsConfirmationSetup) {
    const onboardingContext = useContext(OnboardingContext)
    const { t } = useTranslation()

    return <Stack direction="column" className={`onboardingManageUsersConfirmationSetup`} gap={4} flex={1}>
        <SideMenuItem
            item={{
                text: t("manage-accounts-confirmation-txt"),
                name: "onboarding-right-now"
            }}
            variant="soloItem"
            menuItemClick={() => {
                onboardingContext.setIsAgency(true)
                onboardingContext.handleNext()
            }}
            selected={false}
        />

        <SideMenuItem
            item={{
                text: t("general-not-right-now"),
                name: "onboarding-not-right-now"
            }}
            variant="soloItem"
            menuItemClick={() => {
                onboardingContext.setIsAgency(false)
                onboardingContext.handleNext()
            }}
            selected={false}
        />
    </Stack>
}

export default ManageAccountsConfirmationSetup